import { useAppContext } from "src/hooks/useAppContext";

type Props = {
  remainingTrialDays: number | null;
};

export function useCampaign(props: Props) {
  const { remainingTrialDays } = props;

  const context = useAppContext();

  // Explicitly type the result as boolean
  const isCampaignValid: boolean = Boolean(
    context.currentOrg?.preferences?.settings?.["with_campaign_50_percent_discount_june_2025"] && remainingTrialDays
  );
  return { isCampaignValid };
}
